<template>
  <div v-if="conductorApiId">
    <div class="main-title" :style="{ borderColor: themeColor }">
      {{ conductorApiId }}[{{ conductorUrl }}]readOnly:{{ readOnly }}
      <router-link tag="button" :to="{ name: 'conductorApiEdit' }">
        Update
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ConductorApiSelect',
  computed: mapState([
    'conductorApiId',
    'conductorUrl',
    'readOnly',
    'themeColor'
  ])
}
</script>

<style scoped>
.main-title {
  text-align: center;
  border: 1px solid;
  font-weight: bold;
}
</style>
